/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_005: Question = {
  id: 'multi-005-reglement-eaux-pluviales',
  oldId: '66',
  title: 'Adoption d\'un règlement interdisant l’envoi des eaux pluviales dans les réseaux d’égouts dans les nouvelles constructions',
  number: '6.1',
  description: ['Actions en faveur de la gestion d\'eau'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 9,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_005__v3: Question = {
  ...question_multi_005,
  frequency: 4,
};

export const question_multi_005_v2: Question = question_multi_005;
export const question_multi_005_v3: Question = question_multi_005__v3;
